import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * Products the cart page should move to the top of its display order (SPR-2847).
 * The cart-page add flows (free shipping suggestions, time to restock, quick item
 * entry, move from Save for Later) push the added vendorProductId after a
 * successful add; useCartDisplayOrder applies it once the product is in the cart
 * data and removes it. A failed add pushes nothing, so no request can go stale.
 */
export interface CartSortSliceState {
  promotedVendorProductIds: Array<number>;
}

const initialState: CartSortSliceState = {
  promotedVendorProductIds: [],
};

export const cartSortSlice = createSlice({
  name: "cartSortSlice",
  initialState,
  reducers: {
    promoteCartProduct: (state, action: PayloadAction<number>) => {
      if (!state.promotedVendorProductIds.includes(action.payload)) {
        state.promotedVendorProductIds.push(action.payload);
      }
    },
    cartPromotionsApplied: (state, action: PayloadAction<Array<number>>) => {
      state.promotedVendorProductIds = state.promotedVendorProductIds.filter((id) => !action.payload.includes(id));
    },
  },
});

export const { promoteCartProduct, cartPromotionsApplied } = cartSortSlice.actions;

export default cartSortSlice;
